import { useEffect, useState } from 'react'
import { ForYouProp } from 'models/sectionForYou'
import { getForYou } from 'services/forYou'

export const useForYouController = () => {
  const [dataForYou, setForYou] = useState<ForYouProp>([])
  const [loadingForYou, setLoading] = useState(true)

  useEffect(() => {
    getForYou().then(data => {
      setForYou(data)
      setLoading(false)
    })
  }, [])

  return {
    dataForYou,
    loadingForYou,
  }
}
